import Avatar from "../../../components/Avatar";
import Select from "react-select";

interface OptionType {
  value: string;
  label: string;
  icon?: string;
}

interface SelectPropsType {
  options: OptionType[];
  value: string;
  onChange: (id: string) => void;
  hideIcon?: boolean;
  isGrid?: boolean;
}

const CustomSelect = (props: SelectPropsType) => {
  const { options = [], value, onChange } = props;
  const activeItem = options.find((option) => option.value === value);

  return (
    <Select
      options={options}
      menuPlacement={"auto"}
      value={activeItem}
      formatOptionLabel={(option) => {
        return (
          <div
            className={"w-full hover:text-blue-600 flex items-center space-x-2"}
            key={option.value}
          >
            <div>{option.icon && <Avatar avatarUrl={option.icon} />}</div>
            <div>{option.label}</div>
          </div>
        );
      }}
      onChange={(newValue) => {
        onChange(newValue.value);
      }}
    />
  );
};

export default CustomSelect;
